import { Injectable } from '@angular/core';
import { Router, Resolve, RouterStateSnapshot,
         ActivatedRouteSnapshot , ParamMap} from '@angular/router';
import { Observable, of } from 'rxjs';
import { FrmEventBus } from '../eventbus/frm-evenbus';


@Injectable()
export class FunctionResolver implements Resolve<any> {

  constructor( private router: Router, private feb: FrmEventBus) {}

  editvalue: any;

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    const id = route.paramMap.get('funcid');
    this.editvalue = null;
    this.feb.on('frmopenfunc', (value: any) => {
          this.editvalue = value;
    });
    return of(this.editvalue);
  }
}
